// @ts-check

import $ from "jquery";

/**
 * Pasted from states-options.json which was generated by data-helper/states-countries.js
 */
const stateList = {
  USA: [
    { AL: "Alabama - AL" },
    { AK: "Alaska - AK" },
    { AZ: "Arizona - AZ" },
    { AR: "Arkansas - AR" },
    { CA: "California - CA" },
    { CO: "Colorado - CO" },
    { CT: "Connecticut - CT" },
    { DE: "Delaware - DE" },
    { DC: "District Of Columbia - DC" },
    { FL: "Florida - FL" },
    { GA: "Georgia - GA" },
    { HI: "Hawaii - HI" },
    { ID: "Idaho - ID" },
    { IL: "Illinois - IL" },
    { IN: "Indiana - IN" },
    { IA: "Iowa - IA" },
    { KS: "Kansas - KS" },
    { KY: "Kentucky - KY" },
    { LA: "Louisiana - LA" },
    { ME: "Maine - ME" },
    { MD: "Maryland - MD" },
    { MA: "Massachusetts - MA" },
    { MI: "Michigan - MI" },
    { MN: "Minnesota - MN" },
    { MS: "Mississippi - MS" },
    { MO: "Missouri - MO" },
    { MT: "Montana - MT" },
    { NE: "Nebraska - NE" },
    { NV: "Nevada - NV" },
    { NH: "New Hampshire - NH" },
    { NJ: "New Jersey - NJ" },
    { NM: "New Mexico - NM" },
    { NY: "New York - NY" },
    { NC: "North Carolina - NC" },
    { ND: "North Dakota - ND" },
    { OH: "Ohio - OH" },
    { OK: "Oklahoma - OK" },
    { OR: "Oregon - OR" },
    { PA: "Pennsylvania - PA" },
    { PR: "Puerto Rico - PR" },
    { RI: "Rhode Island - RI" },
    { SC: "South Carolina - SC" },
    { SD: "South Dakota - SD" },
    { TN: "Tennessee - TN" },
    { TX: "Texas - TX" },
    { UT: "Utah - UT" },
    { VT: "Vermont - VT" },
    { VA: "Virginia - VA" },
    { WA: "Washington - WA" },
    { WV: "West Virginia - WV" },
    { WI: "Wisconsin - WI" },
    { WY: "Wyoming - WY" },
    { AA: "APO-FPO Americas - AA" },
    { AE: "APO-FPO Europe - AE" },
    { AP: "APO-FPO Pacific - AP" },
    { AS: "American Samoa - AS" },
    { CZ: "Canal Zone - CZ" },
    { GU: "Guam - GU" },
    { MH: "Marshall Islands - MH" },
    { MP: "Northern Mariana Islands - MP" },
    { TT: "Trust Territories - TT" },
    { TP: "US Territories/Possessions - TP" },
    { VI: "Virgin Islands - VI" },
  ],
  CAN: [
    { AB: "Alberta - AB" },
    { BC: "British Columbia - BC" },
    { LB: "Labrador - LB" },
    { MB: "Manitoba - MB" },
    { NB: "New Brunswick - NB" },
    { NF: "Newfoundland - NF" },
    { NT: "Northwest Territories - NT" },
    { NS: "Nova Scotia - NS" },
    { NU: "Nunavut - NU" },
    { ON: "Ontario - ON" },
    { PE: "Prince Edward Island - PE" },
    { PQ: "Quebec - PQ" },
    { SK: "Saskatchewan - SK" },
    { YT: "Yukon Territory - YT" },
  ],
  AUS: [
    { ACT: "Australian Capital Territory - ACT" },
    { NSW: "New South Wales - NSW" },
    { NT: "Northern Territory - NT" },
    { QLD: "Queensland - QLD" },
    { SA: "South Australia - SA" },
    { TAS: "Tasmania - TAS" },
    { VIC: "Victoria - VIC" },
    { WA: "Western Australia - WA" },
  ],
};

/**
 * Disable all divider <option> elements whose value is '---'
 */
$(document).on("gform_post_render", function (elem, formId, fieldId) {
  $("option[value='---']").prop("disabled", true);
});

/**
 * Enhanced User Interface select elements use the Chosen library.
 * After updating the underlying select options, trigger the jQuery
 * chosen:updated event to recreate the visual element from the new
 * options.
 *
 * @link https://harvesthq.github.io/chosen/#change-update-events
 *
 * NOTE: Dynamic state/country fields have the following classes added:
 *  - Country: .country_select
 *  - State: .state_select
 */
function updateStatesList(stateField, countryCode) {
  const stateSelect = stateField.querySelector("select");
  const prevValue = stateSelect.value;  // store previous value
  const stateLabel = stateField.querySelector("label");
  const requiredSpan = stateLabel.querySelector(".gfield_required");
  // NOTE: may need to clone that with requiredSpan.cloneNode(true) ?
  const stateOrProvince = countryCode === "CAN" ? "Province" : "State";

  if (!stateSelect) {
    return;
  }

  // update label
  if (stateLabel) {
    stateLabel.textContent = stateOrProvince;
    stateLabel.appendChild(requiredSpan);
  }

  stateSelect.innerHTML = "";

  // Prefix options with a null placeholder
  const placeholder = document.createElement("option");
  placeholder.value = "";
  placeholder.textContent = `Select a ${stateOrProvince}`;
  stateSelect.add(placeholder);

  // Update state/province options from the stateList
  stateList[countryCode].forEach((state) => {
    const [code, name] = Object.entries(state)[0];
    const option = document.createElement("option");
    option.value = code;
    option.textContent = name;
    stateSelect.add(option);
  });

  stateSelect.value = prevValue;  // try to re-assign previous value

  // Update Enhanced User Interface (Chosen) options
  $(stateSelect).trigger("chosen:updated");
}

/*
 * For .country_select fields,  the closest .state_select field closest to a changed
 * When .country_select fields change, find the closest .state_select field and
 * update it's list of options based on the inputField's value (countryCode).
 */
function findClosestStateSelect(inputField) {
  const countrySelect = inputField.closest(".country_select");
  const countryCode = inputField.value;

  if (!countrySelect || !stateList[countryCode]) return;

  const stateSelectClass = ".state_select";

  let count = 0;
  let next = countrySelect.nextElementSibling;
  let prev = countrySelect.previousElementSibling;
  while (next && prev && count < 5) {
    if (next.matches(stateSelectClass)) {
      updateStatesList(next, countryCode);
      break;
    }

    if (prev.matches(stateSelectClass)) {
      updateStatesList(prev, countryCode);
      break;
    }

    next = next.nextElementSibling;
    prev = prev.previousElementSibling;
    count++;
  }
}

/**
 * Fix animation to prevent re-wrap when swapping State/Locale
 *
 * On 'hide' actions, check that the target is either a .state_select or
 * the immediate sibling of a .state_select. If true, hide the target
 * immediately to prevent re-wrapping when the alternate field appears.
 */
function hideStateSwapsImmediately(formId, action, targetId) {
  if (action !== "hide") return;

  const target = document.querySelector(targetId);
  if (!target) return;

  const isStateSelect = (el) => el?.classList.contains("state_select");

  if (
    isStateSelect(target) ||
    isStateSelect(target.nextElementSibling) ||
    isStateSelect(target.previousElementSibling)
  ) {
    target.style.display = "none";
  }
}

// @ts-ignore (gform)
if (typeof gform !== "undefined") {
  // @link https://docs.gravityforms.com/gform_input_change/
  // @ts-ignore
  gform.addAction("gform_input_change", findClosestStateSelect);

  // @link https://docs.gravityforms.com/gform_post_conditional_logic_field_action/
  // @ts-ignore
  gform.addAction(
    "gform_post_conditional_logic_field_action",
    hideStateSwapsImmediately,
  );
}

// Update state lists on page load/DOMready;
$(() => {
  document
    .querySelectorAll(".state_select")
    .forEach((stateSelect) => updateStatesList(stateSelect, "USA"));
});
